import { organizationMapper } from './mappers/organizationMapper';
import { updateInterviewMapper } from './mappers/updateInterviewMapper';
import {
  UPDATE_COMPANY_INFO,
  UPDATE_INTERVIEW,
} from '../../stores/actions.type';
export function requestMapper(action, request) {
  const mapper =
    {
      [UPDATE_COMPANY_INFO]: organizationMapper,
      [UPDATE_INTERVIEW]: updateInterviewMapper,
    }[action] || null;

  return mapper ? mapper(request) : request;
}
